import { WrapperField } from '../InputField/WrapperField';
import { useTranslation } from '../../store/context/TranslationContext';
import NumberField from '../InputField/NumberField';

const normalizeTestIdSegment = (value) => String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

const getQuestionLabel = (field, jsonField) => jsonField?.label || field;

const TransactionTable = ({
    asLabel,
    config = {
        fields: [],
        cyclosFields: {}
    },
    data,
    hasError,
    handleErrors,
    isForEDD,
    handleUpdateFormData,
    showInputColumns,
    actualTransactions = {}
}) => {
    const { t } = useTranslation();
    const fieldMap = config?.cyclosFields || {};
    const configFields = Array.isArray(config?.fields) ? config.fields : [];
    return (
        <div className='transaction-table p-0 mb-3' data-testid='transaction-table'>
            <table className="transaction-value-table" data-testid='transaction-table-grid'>
                <thead>
                    <tr>
                        <th className="header-cell">{t("Question")}</th>
                        <th className="header-cell text-end value-cell">{t("Current Expected Activity")}</th>
                        <th className="header-cell text-end value-cell">{t("Actual Activity")}</th>
                        {!showInputColumns ? null : <th className="header-cell text-end value-cell">{t("New Expected Activity")}</th>}
                    </tr>
                </thead>
                <tbody>
                    {
                        configFields.map((field) => {
                            const json = fieldMap?.[field];
                            const selfDeclaredValue = data?.selfDeclaredValues?.[field];
                            const actualValue = actualTransactions?.[field];
                            const actualMore = selfDeclaredValue < actualValue;
                            const rowTestId = `transaction-row-${normalizeTestIdSegment(field) || 'field'}`;
                            return <tr key={field} data-testid={rowTestId}>
                                <td data-testid={`${rowTestId}-question`}>{t(getQuestionLabel(field, json))}</td>
                                <td className='text-end fw-medium' data-testid={`${rowTestId}-current`}>
                                    <NumberField value={selfDeclaredValue} asLabel />
                                </td>
                                <td className='text-end fw-medium' style={{ color: actualMore ? '#F00' : '#008000' }} data-testid={`${rowTestId}-actual`}>
                                    {actualValue !== undefined && actualValue !== null
                                        ? <NumberField value={actualValue} asLabel />
                                        : <span className='value-not-available'> None</span>}
                                </td>
                                {asLabel ? null : <td className='p-0 m-0 transaction-input' data-testid={`${rowTestId}-new`}>
                                    {json?.uiType ? (
                                        <WrapperField
                                            disabled={asLabel}
                                            jsonField={json}
                                            dataObj={data}
                                            onChange={handleUpdateFormData}
                                            showError={hasError}
                                            onError={(errorMsg) => handleErrors(field, errorMsg)}
                                            isForEDD={isForEDD}
                                            customProp={"plain"}
                                        />
                                    ) : <span className='value-not-available'>None</span>}
                                </td>}
                            </tr>
                        })
                    }
                </tbody>
            </table>
        </div>
    )
}

export default TransactionTable;
